import type { FaireProductEntity } from "../../entity_types/product";

export const p_jd2qsdk5du: FaireProductEntity = {
  token: "p_jd2qsdk5du",
  type: "product",
  name: "Arkansas Razorbacks Rhinestone Enamel Logo Earrings",
  brandToken: "b_emgllltle6",
  brandName: "Canvas Style",
  imageUrl:
    "https://cdn.faire.com/fastly/8def82fb3435196751f8d492530a8fd0877c6b0a5325c09926b504b325af3fe6.jpeg",
  galleryImageUrls: [],
  priceDollars: 14.55,
  description:
    'Sparkle with team pride in these Arkansas Razorbacks Rhinestone Enamel Logo Earrings. Featuring the Razorbacks logo in cardinal enamel surrounded by dazzling rhinestones, set in shiny gold, these earrings combine glamour with school spirit. They’re perfect for fans who want to add a touch of sparkle to their game day look.\n\nDETAILS\nBase Metal with Shiny Gold Plating\n1.5"L x .75"W\nNCAA Officially Licensed',
  tags: [],
  msrpDollars: 52.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:47.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
